import { useMediaQuery } from "@mui/material";
import { useEffect, useMemo } from "react";

export const useScreenOrientation = () => {
  const mobileRegex = new RegExp(
    "Android|webOS|iPhone|iPad|" +
      "BlackBerry|Windows Phone|" +
      "Opera Mini|IEMobile|Mobile",
    "i",
  );
  const isMobile = mobileRegex.test(navigator.userAgent);
  const isLandscape = useMediaQuery("(orientation:landscape)");

  const isMobileLandscape = useMemo(() => isLandscape && isMobile, [
    isLandscape,
    isMobile,
  ]);

  useEffect(() => {
    const htmlRef = document.getElementsByTagName("body")[0];

    if (isMobileLandscape) {
      htmlRef.style.overflow = "hidden";
    } else {
      htmlRef.style.overflow = "unset";
    }
  }, [isMobileLandscape]);

  return { isMobileLandscape };
};
